if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor () {
      super()
      this.form = this.querySelector('form')
      this.submitButton = this.querySelector('button[type="submit"]')
      this.cart = document.querySelector('mini-cart')

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this))
      }
    }

    async onSubmit (event) {
      event.preventDefault()

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      this.handleErrorMessage()
      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('btn-Button_Outline_Loading')

      try {
        const ts = getTimestamp()
        this.form.querySelectorAll('[data-property-ts]').forEach((input) => {
          input.value = ts
        })

        const formData = new FormData(this.form)
        formData.append('sections', 'mini-cart')
        this.cart?.preload()
        const response = await addToCart(formData)
        this.handleSuccess(response)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.submitButton.classList.remove('btn-Button_Outline_Loading')
        this.submitButton.removeAttribute('aria-disabled')
      }
    }

    handleSuccess (data) {
      this.cart?.open(data)
    }

    handleError (error) {
      this.handleErrorMessage(error?.description || error.message || 'An error occurred')
    }

    handleErrorMessage (message = false) {
      const errorElement = this.querySelector('[data-error-message]')
      if (!errorElement) return

      errorElement.classList.toggle('pdp-ProductError_Hidden', !message)
      if (message) {
        errorElement.textContent = message
      }
    }
  }

  customElements.define('product-form', ProductForm)
}
